import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { WtStorageService } from 'src/app/wt-storage.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private readonly wtStorage: WtStorageService,
    private readonly router: Router
  ) { }

  externalAPiList = ['api.what3words.com', `thingproxy.freeboard.io`, 'www.googleapis.com'];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headersConfig: any = {};

    // Set Content-Type for non-upload requests
    if (req.url.indexOf('upload') == -1) {
      headersConfig['Content-Type'] = 'application/json';
    }

    // Check if this is an external API call
    const isExternalApi = this.externalAPiList.findIndex((r) => req.url.indexOf(r) > -1) > -1;

    // Add Authorization header for internal API calls if token exists
    // Note: We simply check if token exists in localStorage, and let the backend
    // validate the token. This avoids race conditions with expiry time storage.
    if (!isExternalApi) {
      const accessToken = this.wtStorage.getItem('access_token');
      if (accessToken) {
        headersConfig['Authorization'] = `Bearer ${accessToken}`;
      }
    }

    // DEPRECATED: Organization header - now sent via JWT claims
    // Keeping for backward compatibility during migration
    // TODO: Remove this after Phase 3 is complete and backend is fully migrated
    if (!isExternalApi) {
      const user = this.wtStorage.getuser();
      if (user) {
        headersConfig['org'] = user.organizationId.toString();
      }
    }

    req = req.clone({ setHeaders: headersConfig });

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized - clear cache and redirect to login
        if (error.status === 401 && !isExternalApi) {
          console.warn('Received 401 Unauthorized - logging out and redirecting to login');
          this.handleUnauthorized();
        }
        return throwError(() => error);
      })
    );
  }

  private handleUnauthorized(): void {
    // Clear all auth-related data from storage
    this.wtStorage.removeItem('access_token');
    this.wtStorage.removeItem('refresh_token');
    this.wtStorage.removeItem('token_expiry');
    this.wtStorage.clear();

    // Clear cookies
    this.deleteCookie('l_o');
    this.deleteCookie('liveEventPrompt');

    // Redirect to login page
    this.router.navigate(['/login']);
  }

  private deleteCookie(name: string): void {
    const date = new Date();
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
  }
}
